import { motion } from 'motion/react';
import styled from 'styled-components';

import { OnboardingPage } from '@/pages/Onboarding/components/Page';
import { SendPhotosOptionIdType } from '@/pages/Onboarding/options/SendPhotos/types';

export const SendPhotosStyles = styled(OnboardingPage)`
  .local-title {
    margin: 0 0 8px;
  }

  ion-content {
    &::part(scroll) {
      display: grid;
      padding: 26px 0;
      place-items: flex-end;
      justify-content: center;
      padding: 0 0 48px;
    }
  }
`;

export const SendPhotosAnswersStyles = styled.div`
  margin: 28px 0 0;
  padding: 0 12px;
  display: flex;
  align-items: stretch;
  gap: 12px;
  justify-content: center;
`;

export const SendPhotosIconStyles = styled.div`
  width: 100px;
  aspect-ratio: 1/1;
  background: linear-gradient(225deg, #9b6ac6 -0.32%, #6f2d75 99.68%);
  border-radius: 50%;
  display: grid;
  place-items: center;
  margin: 0 auto 32px;
`;

export const SendPhotosAnswerItemStyles = styled(motion.div)<{
  answer: SendPhotosOptionIdType;
  isSelected: boolean;
}>`
  display: flex;
  flex-grow: 1;
  padding: 14px 25px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border-radius: 12px;
  background: #765279;
  cursor: pointer;
  user-select: none;

  ${({ isSelected }) => isSelected && 'background: #FFC9FB;'}

  .answer-title {
    ${({ isSelected }) => isSelected && 'color: #171123;'}
  }

  .answer-description {
    border-radius: 24px 24px 24px 0px;
    background: linear-gradient(0deg, #602a65 0%, #852c8d 100%);
    padding: 8px 16px;
    margin: 8px 0 0;

    ${({ answer }) =>
      answer === 'yes' &&
      `
        border-radius: 24px 24px 24px 0px;
        background: linear-gradient(0deg, #602a65 0%, #852c8d 100%);
      `}

    ${({ answer }) =>
      answer === 'no' &&
      `
        border-radius: 24px 24px 0px 24px;
        background: linear-gradient(0deg, #4A266D 0%, #60318D 100%);
  `}
  }
`;
